import NavBar from "./NavBar";
import { Outlet } from "react-router-dom";
export default function LayOut(){
    return(
        <>
            <NavBar />
            <Outlet />
        </>
    )

}